/**
 * @method enum DISPLAY
 */
export enum DISPLAY {
  principal = 'principal',
  navbar = 'navbar'
}
